(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "react", "@blueprintjs/core", "../../../../utils/translate"], b);else if ("undefined" != typeof exports) b(exports, require("react"), require("@blueprintjs/core"), require("../../../../utils/translate"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.react, a.core, a.translate), a.SignupFormRenderer = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d) {
  "use strict";

  var e = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.SignupFormRenderer = void 0, b = e(b), d = e(d);

  var f = function f(_ref) {
    var a = _ref.submit,
        e = _ref.setSignupProperty,
        _ref$errors = _ref.errors;
    _ref$errors = _ref$errors === void 0 ? {} : _ref$errors;
    var k = _ref$errors.email,
        l = _ref$errors.password,
        f = _ref.showPassword,
        g = _ref.loading,
        h = _ref.done,
        i = _ref.sentMail,
        _ref$translate = _ref.translate,
        j = _ref$translate === void 0 ? (0, d.default)({
      "auth.signupform.email.invalid": "Invalid email",
      "auth.signupform.email.help": "Type your email",
      "auth.signupform.email.label": "Email",
      "auth.signupform.email.info": "required",
      "auth.signupform.email.placeholder": "Email",
      "auth.signupform.password.invalid": "Password is required",
      "auth.signupform.password.help": "Type your password",
      "auth.signupform.password.label": "Password",
      "auth.signupform.password.info": "required",
      "auth.signupform.password.placeholder": "Password",
      "auth.signupform.submit": "Create account",
      "auth.signupform.submitSuccess": "Email sent to {{email}}"
    }) : _ref$translate;
    return b.default.createElement(c.Card, {
      className: "signup-form"
    }, h && b.default.createElement(c.Callout, {
      className: "signup-form__callout",
      intent: c.Intent.SUCCESS
    }, j("auth.signupform.submitSuccess", {
      email: i
    })), b.default.createElement("form", {
      onSubmit: a
    }, b.default.createElement(c.FormGroup, {
      helperText: j("auth.signupform.email.help"),
      label: j("auth.signupform.email.label"),
      labelFor: "email",
      labelInfo: j("auth.signupform.email.info"),
      intent: k ? c.Intent.WARNING : null
    }, b.default.createElement(c.InputGroup, {
      type: "email",
      id: "email",
      placeholder: j("auth.signupform.email.placeholder"),
      onChange: e,
      intent: k ? c.Intent.WARNING : null,
      autoComplete: "username"
    })), f && b.default.createElement(c.FormGroup, {
      helperText: j("auth.signupform.password.help"),
      label: j("auth.signupform.password.label"),
      labelFor: "password",
      labelInfo: j("auth.signupform.password.info"),
      intent: l ? c.Intent.WARNING : null
    }, b.default.createElement(c.InputGroup, {
      type: "password",
      id: "password",
      placeholder: j("auth.signupform.password.placeholder"),
      onChange: e,
      intent: l ? c.Intent.WARNING : null,
      autoComplete: "current-password"
    })), b.default.createElement(c.Button, {
      type: "submit",
      disabled: g
    }, j("auth.signupform.submit"))));
  };

  a.SignupFormRenderer = f;
  a.default = f;
});